export function clampDragPreviewPosition(sourceX, sourceY, elementWidth, elementHeight, bounds) {
  const clampedX = Math.max(bounds.left, Math.min(bounds.right - elementWidth, sourceX));
  const clampedY = Math.max(bounds.top, Math.min(bounds.bottom - elementHeight, sourceY));
  return {
    deltaX: clampedX - sourceX,
    deltaY: clampedY - sourceY
  };
}